import { render } from "./telaInicialView.vue?vue&type=template&id=0d1884f4&scoped=true"
import script from "./telaInicialView.vue?vue&type=script&lang=js"
export * from "./telaInicialView.vue?vue&type=script&lang=js"

import "./telaInicialView.vue?vue&type=style&index=0&id=0d1884f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1884f4"]])

export default __exports__